import { z } from 'zod'

import { paginacaoSearchFields, toLimitOffset } from '@/widgets/data-table/table-search'

import type { TransferListParams } from './api'

/** Search params da tela de Relatórios › Transferências. */
export const transferenciasSearchSchema = z.object({
  ...paginacaoSearchFields,
  q: z.string().min(1).optional(),
  conta: z.uuid().optional(),
  de: z.iso.date().optional(),
  ate: z.iso.date().optional(),
  ordenar: z
    .enum(['transfer_date', '-transfer_date', 'amount', '-amount', 'created_at', '-created_at'])
    .default('-transfer_date'),
})

export type TransferenciasSearch = z.infer<typeof transferenciasSearchSchema>

/** Default do backend: mais recentes primeiro (transfer_service._ORDER_BY_DEFAULT). */
export const TRANSFERENCIAS_ORDEM_DEFAULT =
  '-transfer_date' satisfies TransferenciasSearch['ordenar']

export const TRANSFERENCIAS_FILTROS = [
  'q',
  'conta',
  'de',
  'ate',
] as const satisfies readonly (keyof TransferenciasSearch)[]

export function toTransferListParams(s: TransferenciasSearch): TransferListParams {
  return {
    ...(s.q !== undefined && { search: s.q }),
    // `bank_account_id` casa origem OU destino: "as transferências desta conta"
    // é a pergunta que se faz, não "as que saíram desta conta".
    ...(s.conta !== undefined && { bank_account_id: s.conta }),
    ...(s.de !== undefined && { date_from: s.de }),
    ...(s.ate !== undefined && { date_to: s.ate }),
    order_by: s.ordenar,
    ...toLimitOffset(s),
  }
}
